import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useRef} from 'react';

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui';

import {BNPL_PAGE_TYPE, ZIP_WIDGET_ASSET} from '@amblique/king-living/app/constants/bnpl-messaging';
import {useZipScriptRescan} from '@amblique/king-living/app/hooks/use-bnpl-script';
import {useZipWidgetA11y} from '@amblique/king-living/app/hooks/use-zip-widget-a11y';

const ZipMessaging = ({
  amount,
  config,
  currencySymbol = '$',
  pageType,
  styles,
}) => {
  const intl = useIntl();
  const containerRef = useRef(null);
  const {environment, merchantPublicKey, region, scriptUrl} = config;
  const isConfigured = Boolean(region && amount);

  useZipScriptRescan(isConfigured, scriptUrl);

  const logoLabel = intl.formatMessage({
    defaultMessage: 'Zip payment information',
    id: 'bnpl_messaging.zip.logo.aria_label',
  });

  const infoLabel = intl.formatMessage({
    defaultMessage: 'Zip terms and conditions',
    id: 'bnpl_messaging.zip.info.aria_label',
  });

  useZipWidgetA11y(containerRef, {
    enabled: isConfigured,
    infoLabel,
    logoLabel,
  });

  if (!isConfigured) {
    return null;
  }

  const isCart = pageType === BNPL_PAGE_TYPE.CART;

  return (
    <Box ref={containerRef} className="bnpl-messaging__zip" sx={styles?.zipWidget}>
      <div
        id={isCart ? 'zip-cart-widget' : 'zip-product-widget'}
        style={{cursor: 'pointer'}}
        data-zm-widget="popup"
        data-zm-region={region}
        data-env={environment}
        data-zm-merchant={merchantPublicKey || undefined}
        data-zm-price={amount}
        data-zm-asset={isCart ? ZIP_WIDGET_ASSET.CART : ZIP_WIDGET_ASSET.PRODUCT}
        data-zm-popup-asset="termsdialog"
        data-zm-symbol={currencySymbol}
      />
    </Box>
  );
};

ZipMessaging.displayName = 'ZipMessaging';
ZipMessaging.propTypes = {
  amount: PropTypes.string,
  config: PropTypes.shape({
    environment: PropTypes.string,
    merchantPublicKey: PropTypes.string,
    region: PropTypes.oneOf(['au', 'nz']),
    scriptUrl: PropTypes.string,
  }).isRequired,
  currencySymbol: PropTypes.string,
  pageType: PropTypes.oneOf([BNPL_PAGE_TYPE.PRODUCT, BNPL_PAGE_TYPE.CART]).isRequired,
  styles: PropTypes.object,
};

export default ZipMessaging;
